import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const fleetDm = defineConnector({
  identifier: "fleetDm",
  name: "Fleet",
  tagLine: "Open source device management",
  logo,
  protocol: "http",
  tags: ["it", "security"],
  defaultUrlPattern: ({ serverUrl }) => domainToRegex(serverUrl),
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Get your Fleet API token",
      items: [
        {
          kind: "markdown",
          content: `1. In Fleet, go to **Account Settings**
2. Click “Get API token”
3. Copy the token`,
        },
      ],
    },
    {
      title: "Enter your Fleet details",
      items: [
        {
          kind: "url",
          label: "Server URL",
          required: true,
          placeholder: "https://fleet.example.com",
          target: { kind: "configuration", field: "serverUrl" },
          helperText: "The base URL of your Fleet server.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ serverUrl }) => `${serverUrl}/api/v1/fleet/hosts?per_page=1`,
  },
});
